import { Extension } from "@tiptap/core";

import { isColor, mirrorColor } from "../utils/color";

type TableCellBackgroundColorOptions = {
  types: string[];
};

export const TableCellBackgroundColor = Extension.create<TableCellBackgroundColorOptions>({
  name: "tableCellBackgroundColor",

  addOptions() {
    return {
      types: ["tableCell", "tableHeader"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            renderHTML({ backgroundColor }: { backgroundColor?: string }) {
              if (isColor(backgroundColor)) {
                return {
                  class: `bg-${backgroundColor} dark:bg-${mirrorColor(backgroundColor)}`,
                };
              }

              return null;
            },
          },
        },
      },
    ];
  },
});
